import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
const testimonials = [{
  text: 'Ich habe meinen Stundensatz in der ersten Woche von 120 auf 220 CHF erhöht. Die Kunden sehen die KPI-Berichte und fragen nicht mehr nach dem Preis.',
  name: 'Marco Zellweger',
  role: 'Privatlehrer',
  city: 'Zermatt'
}, {
  text: 'Die Field Cards auf dem iPad sind mein bestes Werkzeug. Der Kunde sieht die biomechanischen Diagramme und versteht sofort warum er 300 CHF pro Stunde bezahlt.',
  name: 'Andreas Meier',
  role: 'Ski-Coach',
  city: 'St. Moritz'
}, {
  text: 'Das quadrilinguale Lexikon hat mir in Verbier das Leben gerettet. Arabische, russische und britische Kunden — ich kommuniziere jetzt professionell mit allen.',
  name: 'Lukas Brunner',
  role: 'Elite Instruktor',
  city: 'Verbier'
}, {
  text: 'Für 47.90 CHF habe ich bekommen was ich in 10 Jahren Erfahrung nie hatte. Mein einziges Bedauern ist dass ich nicht früher davon erfahren habe.',
  name: 'Patrick Müller',
  role: 'Ski Instruktor',
  city: 'Adelboden'
}, {
  text: 'Die Checklisten geben mir eine unglaubliche Sicherheit. Ich fühle mich auf jede Situation vorbereitet, egal ob Wetterumschwung oder Notfall.',
  name: 'Thomas Weber',
  role: 'Freeride Guide',
  city: 'Davos'
}];
export function Testimonials() {
  return <section className="py-10 sm:py-14 px-4 bg-white" data-id="element-232">
      <div className="max-w-xl mx-auto" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-234">
          <h2 className="text-2xl sm:text-3xl font-black text-brand-navy mb-3" data-id="element-235">
            Was Instruktoren sagen
          </h2>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-236">
            <div className="flex text-brand-gold" data-id="element-237">
              {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-4 h-4 fill-current" data-id="element-238" />)}
            </div>
            <span className="text-sm font-bold text-brand-navy" data-id="element-239">
              4.9/5 (+200 Bewertungen)
            </span>
          </div>
        </motion.div>

        <div className="space-y-4" data-id="element-240">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-brand-surface border border-brand-border p-5 rounded-2xl shadow-sm" data-id="element-241">
              <div className="flex items-center gap-2 mb-3" data-id="element-242">
                <div className="flex text-brand-gold" data-id="element-243">
                  {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-3.5 h-3.5 fill-current" data-id="element-244" />)}
                </div>
                <span className="inline-flex items-center gap-1 text-[11px] font-bold text-green-600" data-id="element-245">
                  <BadgeCheckIcon className="w-3.5 h-3.5" data-id="element-246" /> Verifiziert
                </span>
              </div>
              <p className="text-brand-text text-sm font-medium italic mb-3 leading-snug" data-id="element-247">
                "{t.text}"
              </p>
              <div className="border-t border-brand-border pt-3 flex flex-wrap justify-between items-center gap-2" data-id="element-248">
                <span className="text-xs text-brand-muted font-medium" data-id="element-249">
                  <span className="font-bold text-brand-navy" data-id="element-250">{t.name}</span> —{' '}
                  {t.role} · 📍 {t.city}
                </span>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-sm font-bold text-brand-navy mt-8" data-id="element-251">
          🚀 SCHLIESS DICH +200 INSTRUKTOREN AN
        </p>
      </div>
    </section>;
}